import posthog from 'posthog-js';
import { router } from '@inertiajs/vue3';

let started = false;
let currentUser = null;
let credentials = null;

function syncIdentity() {
    if (!started) {
        return;
    }

    // posthog restores the distinct ID from its own storage, which outlives the
    // Laravel session, so ask posthog who it thinks we are instead of tracking
    // that here. _isIdentified() has no public equivalent.
    const identifiedId = posthog._isIdentified() ? posthog.get_distinct_id() : null;
    const userId = currentUser ? String(currentUser.id) : null;

    if (identifiedId === userId) {
        return;
    }

    // Covers both a stale identity on a logged out visit and a different user
    // signing in without a logged out page load in between. Anonymous visitors
    // are left alone so their distinct ID survives across page loads.
    if (identifiedId !== null) {
        posthog.reset();
    }

    if (currentUser) {
        posthog.identify(userId, {
            email: currentUser.email,
            name: currentUser.name,
        });
    }
}

/**
 * Boot PostHog. Called at install time when the visitor's stored cookie choice
 * allows analytics.
 */
function start() {
    if (started) {
        return;
    }

    started = true;

    posthog.init(credentials.key, {
        api_host: credentials.host || 'https://wyd.besapro.eu',
        // The api_host is a reverse proxy, so posthog needs the real app host
        // to build links back to itself (toolbar, session replay URLs).
        ui_host: credentials.uiHost || 'https://eu.posthog.com',
        defaults: '2026-05-30',
        // Autocapture reads element text and attributes, which in this app means
        // Teamleader customer data. Mask both so no third-party personal data
        // leaves the browser.
        mask_all_text: true,
        mask_all_element_attributes: true,
    });

    syncIdentity();
}

export const LoadPostHog = {
    install(app, { user = null, config = null } = {}) {
        // The server only shares the credentials in production, so their
        // absence means analytics stay off.
        if (!config?.key) {
            return;
        }

        credentials = config;
        currentUser = user;

        router.on('navigate', (event) => {
            currentUser = event.detail.page.props.auth?.user ?? null;
            syncIdentity();
        });

        // The banner accepts over XHR, so a fresh opt-in only takes effect on
        // the next page load.
        if (config.consented) {
            start();
        }
    },
};
